import { useMemo } from 'react';

import { useQueries } from '@tanstack/react-query';
import { showCauseOptions } from 'core/Api';

const useCausesQueries = (causeIds?: string[]) => {
  const filteredCauseIds = useMemo(() => {
    return causeIds?.filter((causeId) => Boolean(causeId)) ?? [];
  }, [causeIds]);

  const causeQueries = useQueries({
    queries: filteredCauseIds?.map((causeId) => ({
      ...showCauseOptions({ uuid: causeId }),
    })),
  });
  const isCauseQueriesLoading = useMemo(() => {
    return causeQueries.some((query) => query.isLoading);
  }, [causeQueries]);

  const causeNames = useMemo(() => {
    if (isCauseQueriesLoading) return [];
    return causeQueries.map((query) => query.data?.name).filter((name) => name !== undefined);
  }, [causeQueries, isCauseQueriesLoading]);

  const causesNameString = useMemo(
    () => (isCauseQueriesLoading ? '' : (causeNames?.join(', ') ?? '')),
    [causeNames, isCauseQueriesLoading]
  );

  return {
    causesNameString,
    isCauseQueriesLoading,
    causeNames,
  };
};

export { useCausesQueries };
